import clsx from 'clsx'
import LoadingSpinner, { LoadingCaption } from './LoadingSpinner'
import React from 'react'

interface Props {
    children: React.ReactNode | React.ReactNode[]
    show?: boolean
    captions?: LoadingCaption[]
    className?: string
}

function LoadingSpinnerOverlay({
    children,
    show = true,
    captions,
    className,
}: Props): React.JSX.Element {
    if (!show) {
        return <>{children}</>
    }

    const classes = clsx(
        'bg-white p-8 rounded-md shadow-md flex flex-col items-center min-w-[400px] border',
        className,
    )

    return (
        <div className="relative">
            {children}
            {show && (
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-25 rounded-md">
                    <div className={classes}>
                        <LoadingSpinner show={true} captions={captions} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default LoadingSpinnerOverlay
